import 'regenerator-runtime/runtime';

import '../components/scss/main.scss';
console.log('v1');

import { v } from '../components/js/viewport.js';
import model from './elco.gltf';
import hdr from '../assets/urban.hdr';

import './data';

import {
    initNav
} from '../components/js/navigation.js';

import * as P from '../components/js/products';
import * as I from '../components/js/interaction.js';

const main = async () => {

    window.canvas = document.querySelector('#canvas');

    await v.init(canvas, hdr, model);

    $('#loading-screen').animate({opacity: '0%'},{duration: 1000, complete: function(){
        console.log('finished');
        I.createHideCameraTween(window.cameras[0]);
        setTimeout(() => {
            $('#loading-screen').remove();
        }, 1000);
    }});

    initNav();

    I.createReset();

    window.cameras.forEach(x => {
        I.createCamera(x, 'camera-elements')
    })

    createObjects();

    await P.reqProducts();
    P.createCards();
}

window.onload = main;

export const createObjects = () => {

    $('#main-elements').on('mouseleave', () => {
            v.hideOutlines();
            v.requestRenderIfNotRequested();
    })

    const objects = v.objects;

    const group0 = objects.filter(x => x.name.substring(0, 1) === '0');
    const group00 = objects.filter(x => x.name.substring(0, 2) === '00');
    const group01 = objects.filter(x => x.name.substring(0, 2) === '01');
    const group02 = objects.filter(x => x.name.substring(0, 2) === '02');
    const group03 = objects.filter(x => x.name.substring(0, 2) === '03');
    const group04 = objects.filter(x => x.name.substring(0, 2) === '04');
    const group1 = objects.filter(x => x.name.substring(0, 1) === '1');
    const group2 = objects.filter(x => x.name.substring(0, 1) === '2');
    const group3 = objects.filter(x => x.name.substring(0, 1) === '3');



    I.createGroup('group0', 'Gebäude', group0, 'main');
    group00.forEach(x => I.createObject(x, 'group0'));
    
    I.createGroup('group01', 'Außenwand', group01, 'group0');
    group01.forEach(x => I.createObject(x, 'group01'));

    
    I.createGroup('group02', 'Innenwand', group02, 'group0');
    group02.forEach(x => I.createObject(x, 'group02'));
    I.createGroup('group03', 'Böden', group03,'group0');
    group03.forEach(x => I.createObject(x, 'group03'));
    I.createGroup('group04', 'Dach', group04,'group0');
    group04.forEach(x => I.createObject(x, 'group04'));

    I.createGroup('group1', 'Heizung', group1, 'main');
    group1.forEach(x => I.createObject(x, 'group1'));
    I.createGroup('group2', 'Sanitär', group2, 'main');
    group2.forEach(x => I.createObject(x, 'group2'));
    I.createGroup('group3', 'Lüftung', group3, 'main');
    group3.forEach(x => I.createObject(x, 'group3'));

}